import { render, staticRenderFns } from "./ActiveCities.vue?vue&type=template&id=cffedd46&scoped=true"
import script from "./ActiveCities.vue?vue&type=script&lang=ts"
export * from "./ActiveCities.vue?vue&type=script&lang=ts"
import style0 from "./ActiveCities.vue?vue&type=style&index=0&id=cffedd46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cffedd46",
  null
  
)


    import installComponents from "!/user/src/app/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BSpinner, BCol, BRow} from 'bootstrap-vue'
    installComponents(component, {BSpinner, BCol, BRow})
    

export default component.exports